import { ContactUsSM } from "../service-models/contact-us.s-m";
import { BaseViewModel } from "./base.viewmodel";

export class ContactUsViewModel implements BaseViewModel {
    PageTitle: string = 'contact us';
    contacts: ContactUsSM[] = [];
    singleContact: ContactUsSM=new ContactUsSM();
}